module.exports = __webpack_public_path__ + "e7f8c4a0aa4b8c4987946ba80e1a52f0.svg";